export { ProductVariationBadgesConnected as ProductVariationBadges } from './ProductVariationBadgesConnected';
export { useAddInitialProductToCart } from './useAddInitialProductToCart';
